
import { useState, useEffect } from "react";
import ModalContainer from "./ModalContainer";
import ModalInputField from "./ModalInputField";
import { debounce } from "lodash";
import { findItemIndex } from "../functions/commons";
import DoneIcon from "@mui/icons-material/Done";
import { HandleNotification } from "./ToastAlert";

function ModalSearch({
  onDataSave,
  dataList,
  selectedData,
  isVisible,
  onClose,
  subText,
  selectionLimit,
}) {
  const [searchText, setSearchText] = useState("");
  const [selectedListData, setSelectedListData] = useState([]);
  const [renderListData, setRenderListData] = useState([]);

  const [allData, setAllDataList] = useState([]);

  useEffect(() => {
    let list = [];
    let selectedList = [];
    dataList.map((item) => {
      let obj = {};

      let selected = false;
      selectedData.map((selectedItem) => {
        if (item.id === selectedItem.id) {
          obj = {
            id: item.id,
            name: item.name,
            isSelected: true,
          };
          list.push(obj);
          selectedList.push(obj);
          selected = true;
        }
      });
      if (!selected) {
        obj = {
          id: item.id,
          name: item.name,
          isSelected: false,
        };
        list.push(obj);
      }
    });

    setAllDataList(list);
    setRenderListData(list);
    setSelectedListData(selectedList);

    // console.log({ list });
    // console.log({ selectedList });
  }, [dataList, selectedData]);

  const onSelect = (id) => {
    let tempAllData = [...allData];
    let tempSelectedListData = [...selectedListData];
    let tempRenderListData = [...renderListData];

    let indexAllData = findItemIndex(tempAllData, id);
    let indexSelectedListData = findItemIndex(tempSelectedListData, id);
    let indexRenderListData = findItemIndex(tempRenderListData, id);

    if (tempSelectedListData.length === selectionLimit) {
      if (indexSelectedListData != -1) {
        let valueSelectedListData =
          tempSelectedListData[indexSelectedListData].isSelected;

        if (valueSelectedListData) {
          tempSelectedListData.splice(indexSelectedListData, 1);
          setSelectedListData(tempSelectedListData);
          dataSelectDeSelect(
            tempAllData,
            tempRenderListData,
            indexAllData,
            indexRenderListData
          );
        }
      } else {
        if (selectionLimit > 1) {
          HandleNotification(`Cannot select more than ${selectionLimit}`);
        }

        if (
          selectedData.length === 1 &&
          selectedData.length === selectionLimit
        ) {
          const resetAllValuesToFalse = tempAllData.map((item) => {
            // if (item.id !== selectedData[0].id) {
            item.isSelected = false;
            // }
            return item;
          });

          console.log({ resetAllValuesToFalse });
          dataSelectDeSelect(
            resetAllValuesToFalse,
            resetAllValuesToFalse,
            indexAllData,
            indexRenderListData
          );
        }
      }
    } else {
      if (!tempAllData[indexAllData].isSelected) {
        tempSelectedListData.push({
          ...tempAllData[indexAllData],
          isSelected: true,
        });
        setSelectedListData(tempSelectedListData);
      } else {
        if (indexSelectedListData != -1) {
          tempSelectedListData.splice(indexSelectedListData, 1);
          setSelectedListData(tempSelectedListData);
        }
      }

      dataSelectDeSelect(
        tempAllData,
        tempRenderListData,
        indexAllData,
        indexRenderListData
      );
    }
  };

  const dataSelectDeSelect = (
    tempAllData,
    tempRenderListData,
    indexAllData,
    indexRenderListData
  ) => {
    let valueSelectedAllData = !tempAllData[indexAllData].isSelected;

    let valueSelectedListData =
      !tempRenderListData[indexRenderListData].isSelected;

    tempAllData[indexAllData].isSelected = valueSelectedAllData;
    tempRenderListData[indexRenderListData].isSelected = valueSelectedListData;

    setRenderListData(tempRenderListData);
    setAllDataList(tempAllData);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    debouncedSearch(e.target.value);
  };

  const debouncedSearch = debounce(function (query) {
    const tempData = [...allData];
    const filteredData = tempData.filter((item) => {
      return item.name.toLowerCase().includes(query);
    });
    setRenderListData(filteredData);
  }, 1000);

  const onSave = () => {
    let tempDataForReducer = allData
      .filter((filterItem) => filterItem.isSelected)
      .map(({ isSelected, ...rest }) => rest);

    let tempData = tempDataForReducer.map((item) => item.id);
    onDataSave(tempData, tempDataForReducer);
    onClose();
  };

  return (
    <ModalContainer
      onClose={onClose}
      onBtnClick={onSave}
      isVisible={isVisible}
      modalHeaderText={"Let's update your profile"}
      modalSubHeaderText={subText}
    >
      <div>
        <ModalInputField
          name={"fullName"}
          headerText={"Search"}
          onChangeText={(e) => {
            onSearch(e);
          }}
          inputFieldValue={searchText}
        />

        <div>
          {renderListData.map((item) => {
            return (
              <div
                className="modal_search_item"
                onClick={() => onSelect(item.id)}
              >
                <text style={{ fontSize: "18px" }}>{item.name}</text>
                {item.isSelected && <DoneIcon fontSize="large" />}
              </div>
            );
          })}
        </div>
      </div>
    </ModalContainer>
  );
}

export default ModalSearch;
